import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentSipUpiTimerComponent } from './payment-sip-upi-timer.component';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [PaymentSipUpiTimerComponent],
  exports: [PaymentSipUpiTimerComponent],
  imports: [
    CommonModule,
    MatButtonModule
  ]
})
export class PaymentSipUpiTimerModule { }
